import React from 'react';
import PropTypes from 'prop-types';

import { styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import PopoverAnchor from 'common/components/PopoverAnchor';
import ColorAndImagePicker from './ColorAndImagePicker';

import './styles.styl';

const baseClassName = 'ColorAndImageAnchor';

const ColorAndImageAnchor = (props) => (
    <div className={baseClassName}>
        <PopoverAnchor>
            <ColorAndImagePicker {...props} />
        </PopoverAnchor>
    </div>
);

ColorAndImageAnchor.propTypes = {
    colorList: PropTypes.arrayOf(PropTypes.object),
    color: styleShapePropTypes,
    label: PropTypes.string,
    changeColor: PropTypes.func.isRequired,
    imageUrl: PropTypes.string,
    imageBaseUrl: PropTypes.string,
    onChangeImage: PropTypes.func.isRequired,
    onEditImage: PropTypes.func.isRequired,
    qaId: PropTypes.string,
};

ColorAndImageAnchor.defaultProps = {
    colorList: [],
    color: null,
    label: '',
    imageUrl: '',
    imageBaseUrl: '',
    qaId: '',
};

export default ColorAndImageAnchor;
